/* ============================================================================
   assets/mm-video-stories.js — Lecteur vidéo "stories" DA Shapeheart (10.07.2026)
   ============================================================================
   Remplace l'embed YouTube brut de la modale vidéos stories de la fiche
   produit (sections/main-product.liquid, bloc videos_stories) par un lecteur
   propriétaire : segments de progression, tap gauche/droite, swipe, bouton
   son, fermeture 44px — la vidéo reste hébergée sur YouTube mais est pilotée
   via l'API IFrame (controls=0, domaine youtube-nocookie) → aucun chrome
   YouTube, pas de "Plus de vidéos".

   Points d'entrée :
   - window.mmOpenModalVideoStories(videoId, slider, title)
     → signature CONSERVÉE (appelée par les vignettes onclick de
       snippets/mm-pf-preview-video.liquid ; 3e argument titre = ajout 10.07,
       optionnel). slider=true → joue la playlist "stories_id" (JSON embarqué
       dans #mm-vs-data), sinon la seule vidéo videoId.
   - window.mmCloseModalVideo() → conservée aussi (compat).

   Modes :
   - 'yt'     : pilotage API YouTube (cas nominal, IDs alphanumériques).
   - 'iframe' : secours — API YouTube indisponible (bloqueur, réseau) ou ID
     Vimeo (purement numérique) → iframe native dans notre habillage (nos
     segments restent statiques, bouton son masqué via .mm-vs-fallback).

   Données lues dans le DOM (rendues par la section, AUCUN texte en dur ici) :
   - <script id="mm-vs-data" type="application/json">
     { "stories": ["id1", ...], "storiesTitle": "..." }
   ============================================================================ */
(function () {
    'use strict';

    /* ── État interne ─────────────────────────────────────────────────── */
    var S = {
        list: [],          // playlist courante [{id}]
        title: '',         // titre affiché (header)
        idx: 0,            // index vidéo courante
        player: null,      // instance YT.Player
        playerReady: false,
        pendingId: null,   // id demandé avant que le player soit prêt
        muted: true,       // autoplay muet obligatoire (politique navigateurs)
        mode: 'yt',
        timer: null,       // interval de progression
        openerEl: null,    // élément à re-focus à la fermeture
        touch: null,       // point de départ du geste tactile
        open: false,
        errors: 0,         // échecs consécutifs (garde-fou boucle d'erreurs)
        log: []            // journal debug (exposé window.__mmVsLog)
    };
    window.__mmVsLog = S.log; // lecture seule, diagnostic en console

    var YT_TIMEOUT_MS = 3500; // au-delà : bascule en mode iframe (secours)

    function $(sel, root) { return (root || document).querySelector(sel); }

    function modal()   { return $('.mm-vs-modal'); }
    function stage()   { return $('.mm-vs-stage'); }

    /* Données embarquées par la section (stories + libellés). */
    function data() {
        if (S._data) return S._data;
        var node = document.getElementById('mm-vs-data');
        try { S._data = node ? JSON.parse(node.textContent) : {}; }
        catch (e) { S._data = {}; } // JSON invalide → on dégrade sans casser
        return S._data;
    }

    /* ID Vimeo = purement numérique (même convention que l'ancien snippet
       mm-video-frame-youtube-vimeo). */
    function isVimeo(id) { return /^\d+$/.test(String(id || '')); }

    /* ── Chargement API YouTube (une seule fois, à la première ouverture) ── */
    var ytWaiters = [];
    var ytFailed = false;
    function ensureYT(cb) {
        if (window.YT && window.YT.Player) { cb(true); return; }
        if (ytFailed) { cb(false); return; }
        ytWaiters.push(cb);
        if (ytWaiters.length > 1) return; // injection déjà en cours

        var prev = window.onYouTubeIframeAPIReady; // on chaîne si déjà défini
        window.onYouTubeIframeAPIReady = function () {
            if (typeof prev === 'function') { try { prev(); } catch (e) {} }
            flushYT(true);
        };
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        tag.onerror = function () { ytFailed = true; flushYT(false); };
        document.head.appendChild(tag);
        setTimeout(function () {
            if (!(window.YT && window.YT.Player)) { ytFailed = true; flushYT(false); }
        }, YT_TIMEOUT_MS);
    }
    function flushYT(ok) {
        var w = ytWaiters; ytWaiters = [];
        w.forEach(function (cb) { try { cb(ok); } catch (e) {} });
    }

    /* ── Segments de progression ──────────────────────────────────────── */
    function buildSegments() {
        var wrap = $('.mm-vs-segments');
        if (!wrap) return;
        wrap.innerHTML = '';
        for (var i = 0; i < S.list.length; i++) {
            var seg = document.createElement('div');
            seg.className = 'mm-vs-segment';
            seg.innerHTML = '<span class="mm-vs-segment-fill"></span>';
            wrap.appendChild(seg);
        }
        paintSegments(0);
    }
    /* fraction ∈ [0,1] = avancement de la vidéo COURANTE. */
    function paintSegments(fraction) {
        var segs = document.querySelectorAll('.mm-vs-segment');
        for (var i = 0; i < segs.length; i++) {
            var fill = segs[i].firstElementChild;
            segs[i].classList.toggle('is-done', i < S.idx);
            if (i < S.idx) fill.style.width = '100%';
            else if (i === S.idx) fill.style.width = (Math.min(1, Math.max(0, fraction)) * 100) + '%';
            else fill.style.width = '0%';
        }
    }
    function paintHeader() {
        var t = $('.mm-vs-title'), c = $('.mm-vs-counter');
        if (t) t.textContent = S.title || '';
        if (c) {
            c.textContent = (S.idx + 1) + '/' + S.list.length;
            c.hidden = S.list.length < 2; // compteur inutile sur vidéo seule
        }
    }

    /* Boucle de progression (200 ms) — lit le player YouTube. */
    function startProgress() {
        stopProgress();
        S.timer = setInterval(function () {
            if (!S.player || !S.playerReady || S.mode !== 'yt') return;
            try {
                var d = S.player.getDuration();
                var t = S.player.getCurrentTime();
                if (d > 0) paintSegments(t / d);
            } catch (e) { /* player en cours de swap : silencieux */ }
        }, 200);
    }
    function stopProgress() {
        if (S.timer) { clearInterval(S.timer); S.timer = null; }
    }

    /* ── Player YouTube ───────────────────────────────────────────────── */
    function createPlayer(videoId) {
        var host = $('#mm-vs-yt');
        if (!host || !(window.YT && window.YT.Player)) return;
        stage().classList.add('is-loading');
        S.playerReady = false;
        S.player = new YT.Player(host, {
            host: 'https://www.youtube-nocookie.com',
            videoId: videoId,
            playerVars: {
                autoplay: 1, controls: 0, rel: 0, playsinline: 1,
                disablekb: 1, fs: 0, iv_load_policy: 3, mute: 1,
                origin: window.location.origin
            },
            events: {
                onReady: function (e) {
                    S.log.push('ready:' + videoId);
                    S.playerReady = true;
                    // état muet persistant pendant la session de visionnage
                    if (S.muted) e.target.mute(); else { e.target.unMute(); e.target.setVolume(100); }
                    e.target.playVideo();
                    armWatchdog(); // si la lecture ne démarre pas → relance puis secours
                    // une vidéo a été demandée pendant l'init → on la charge
                    if (S.pendingId && S.pendingId !== videoId) {
                        e.target.loadVideoById(S.pendingId);
                    }
                    S.pendingId = null;
                },
                onStateChange: function (e) {
                    S.log.push('state:' + e.data);
                    if (e.data === YT.PlayerState.PLAYING) {
                        S.errors = 0; // une lecture réussie remet le compteur d'erreurs à zéro
                        disarmWatchdog();
                        stage().classList.remove('is-loading');
                        startProgress();
                    } else if (e.data === YT.PlayerState.ENDED) {
                        // fin de vidéo : story suivante ; vidéo seule → boucle
                        if (S.list.length > 1) next(true);
                        else { try { S.player.seekTo(0); S.player.playVideo(); } catch (err) {} }
                    }
                },
                onError: function (e) {
                    // ID invalide / vidéo non intégrable : on avance plutôt que
                    // geler. GARDE-FOUS (10.07) : throttle 400 ms + abandon vers
                    // le mode iframe après un tour complet d'échecs — sans eux,
                    // une playlist entièrement en erreur créait une boucle
                    // onError→loadVideoById→onError qui gelait l'onglet.
                    S.log.push('error:' + (e && e.data));
                    S.errors = (S.errors || 0) + 1;
                    if (S.errors >= S.list.length) {
                        var mEl = modal();
                        S.mode = 'iframe';
                        if (mEl) mEl.classList.add('mm-vs-fallback');
                        destroyPlayer();
                        loadCurrent();
                        return;
                    }
                    if (S.list.length > 1) setTimeout(function () { if (S.open) next(true); }, 400);
                }
            }
        });
    }
    function destroyPlayer() {
        stopProgress();
        disarmWatchdog();
        if (S.player) { try { S.player.destroy(); } catch (e) {} S.player = null; }
        S.playerReady = false;
        // le destroy() remplace la div hôte par l'iframe puis la retire :
        // on recrée la div hôte pour la prochaine ouverture
        var vid = $('.mm-vs-video');
        if (vid) vid.innerHTML = '<div id="mm-vs-yt"></div>';
    }

    /* ── Watchdog de démarrage (10.07) ────────────────────────────────────
       Certains embeds (Shorts notamment) restent en UNSTARTED malgré
       playVideo() — vu en test : ready reçu puis state -1 figé. Stratégie :
       relance douce à 1,5 s, puis à 5 s bascule sur l'iframe de secours
       (contrôles natifs visibles → l'utilisateur peut toujours lancer). */
    function armWatchdog() {
        disarmWatchdog();
        S.nudge = setTimeout(function () {
            if (S.open && S.player && S.playerReady) {
                try { S.player.playVideo(); S.log.push('nudge'); } catch (e) {}
            }
        }, 1500);
        S.watchdog = setTimeout(function () {
            if (!S.open || S.mode !== 'yt') return;
            S.log.push('watchdog->fallback');
            var m = modal();
            S.mode = 'iframe';
            if (m) m.classList.add('mm-vs-fallback');
            destroyPlayer();
            loadCurrent();
        }, 5000);
    }
    function disarmWatchdog() {
        if (S.nudge) { clearTimeout(S.nudge); S.nudge = null; }
        if (S.watchdog) { clearTimeout(S.watchdog); S.watchdog = null; }
    }

    /* Mode secours : iframe native (YouTube nocookie ou Vimeo). */
    function loadFallback(videoId) {
        var vid = $('.mm-vs-video');
        if (!vid) return;
        stage().classList.remove('is-loading');
        var src = isVimeo(videoId)
            ? 'https://player.vimeo.com/video/' + videoId + '?autoplay=1&byline=0&controls=1&muted=1&playsinline=1&title=0'
            : 'https://www.youtube-nocookie.com/embed/' + videoId + '?mute=1&autoplay=1&rel=0&playsinline=1&loop=1&playlist=' + videoId;
        vid.innerHTML = '<iframe src="' + src + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
        paintSegments(0); // progression inconnue en iframe native
    }

    /* Charge la vidéo d'index S.idx selon le mode. */
    function loadCurrent() {
        var id = (S.list[S.idx] || {}).id;
        if (!id) return;
        paintHeader();
        paintSegments(0);
        if (S.mode === 'yt') {
            if (S.player && S.playerReady) {
                stage().classList.add('is-loading');
                try { S.player.loadVideoById(id); armWatchdog(); } catch (e) { S.pendingId = id; }
            } else if (S.player) {
                S.pendingId = id; // player en cours de création
            } else {
                createPlayer(id);
            }
        } else {
            loadFallback(id);
        }
    }

    function next(wrap) {
        if (S.list.length < 2) return;
        if (S.idx + 1 < S.list.length) S.idx++;
        else if (wrap) S.idx = 0; else return;
        loadCurrent();
    }
    function prev() {
        if (S.list.length < 2) return;
        S.idx = S.idx > 0 ? S.idx - 1 : S.list.length - 1;
        loadCurrent();
    }

    /* ── Ouverture / fermeture ────────────────────────────────────────── */
    function openModal(playlist, title) {
        var m = modal();
        if (!m || !playlist.length) return;
        S.list = playlist;
        S.title = title || '';
        S.idx = 0;
        S.open = true;
        S.openerEl = document.activeElement;

        // Vimeo dans la playlist → tout le visionnage passe en mode iframe
        var hasVimeo = playlist.some(function (v) { return isVimeo(v.id); });

        m.classList.remove('mm-none');
        m.classList.remove('mm-vs-fallback');
        document.documentElement.classList.add('mm-vs-lock');
        buildSegments();
        paintHeader();

        // zones de tap + flèches inutiles sur une vidéo seule
        var single = playlist.length < 2;
        document.querySelectorAll('.mm-vs-tap, .mm-vs-arrow').forEach(function (el) {
            el.hidden = single;
        });

        var closeBtn = $('.mm-vs-close');
        if (closeBtn) closeBtn.focus();

        if (hasVimeo) {
            S.mode = 'iframe';
            m.classList.add('mm-vs-fallback');
            loadCurrent();
        } else {
            S.mode = 'yt';
            stage().classList.add('is-loading');
            ensureYT(function (ok) {
                if (!S.open) return; // refermée avant que l'API n'arrive
                if (!ok) { S.mode = 'iframe'; m.classList.add('mm-vs-fallback'); }
                loadCurrent();
            });
        }
    }

    function closeModal() {
        var m = modal();
        if (!m) return;
        S.open = false;
        destroyPlayer();
        var vid = $('.mm-vs-video');
        if (vid) vid.innerHTML = '<div id="mm-vs-yt"></div>'; // purge iframe secours
        m.classList.add('mm-none');
        document.documentElement.classList.remove('mm-vs-lock');
        if (S.openerEl && S.openerEl.focus) { try { S.openerEl.focus(); } catch (e) {} }
        S.openerEl = null;
    }

    /* ── API globale (signatures historiques conservées) ──────────────── */
    window.mmOpenModalVideoStories = function (videoId, slider, title) {
        var d = data();
        if (slider === true) {
            var ids = Array.isArray(d.stories) ? d.stories : [];
            openModal(ids.map(function (id) { return { id: String(id) }; }), d.storiesTitle || title || '');
        } else if (videoId) {
            openModal([{ id: String(videoId) }], title || '');
        }
    };
    window.mmCloseModalVideo = closeModal;

    /* ── Interactions (délégation, listeners posés une seule fois) ────── */
    document.addEventListener('DOMContentLoaded', function () {
        var m = modal();
        if (!m) return; // pas de bloc vidéos sur cette page

        // La modale est rendue au fond du DOM de la fiche produit, où un
        // ancêtre crée un "containing block" (container queries / containment
        // Dawn) : position:fixed s'y ancre au bloc au lieu du viewport → le
        // header du site restait découvert. On la téléporte dans <body>,
        // hors de portée (pattern dialog standard). Constaté sur DEV 10.07.
        if (m.parentElement !== document.body) document.body.appendChild(m);

        // Précharge l'API IFrame en tâche de fond : au clic sur une vignette,
        // le player se crée alors DANS le geste utilisateur (sinon l'autoplay
        // muet peut être refusé — vu en test : ready puis UNSTARTED figé).
        ensureYT(function () {});

        m.addEventListener('click', function (ev) {
            var t = ev.target;
            if (t.closest('.mm-vs-close') || t.classList.contains('mm-vs-backdrop')) { closeModal(); return; }
            if (t.closest('.mm-vs-tap-next') || t.closest('.mm-vs-next')) { next(true); return; }
            if (t.closest('.mm-vs-tap-prev') || t.closest('.mm-vs-prev')) { prev(); return; }
            if (t.closest('.mm-vs-sound')) { toggleSound(); return; }
        });

        // Clavier : Échap ferme, flèches naviguent (desktop)
        document.addEventListener('keydown', function (ev) {
            if (!S.open) return;
            if (ev.key === 'Escape') closeModal();
            else if (ev.key === 'ArrowRight') next(true);
            else if (ev.key === 'ArrowLeft') prev();
        });

        // Tactile : swipe horizontal = nav, swipe vertical bas = fermer
        var st = stage();
        if (st) {
            st.addEventListener('touchstart', function (ev) {
                if (ev.touches.length === 1) {
                    S.touch = { x: ev.touches[0].clientX, y: ev.touches[0].clientY };
                }
            }, { passive: true });
            st.addEventListener('touchend', function (ev) {
                if (!S.touch) return;
                var dx = ev.changedTouches[0].clientX - S.touch.x;
                var dy = ev.changedTouches[0].clientY - S.touch.y;
                S.touch = null;
                if (Math.abs(dy) > Math.abs(dx)) {
                    if (dy > 70) closeModal(); // tirer vers le bas = fermer
                } else if (dx < -50) next(true);
                else if (dx > 50) prev();
            }, { passive: true });
        }

        // Piège à focus minimal : Tab reste dans la modale ouverte
        document.addEventListener('focusin', function (ev) {
            if (S.open && m && !m.contains(ev.target)) {
                var c = $('.mm-vs-close');
                if (c) c.focus();
            }
        });
    });

    function toggleSound() {
        var btn = $('.mm-vs-sound');
        S.muted = !S.muted;
        if (btn) btn.setAttribute('aria-pressed', S.muted ? 'false' : 'true');
        if (S.player && S.playerReady) {
            try {
                if (S.muted) S.player.mute();
                else { S.player.unMute(); S.player.setVolume(100); }
            } catch (e) {}
        }
    }

    /* (ctaAction supprimée le 10.07 — le CTA « Voir le produit » était
       redondant sur la page produit, retour Christopher.) */
})();
